import moment from "moment";
import {
  PublicApiCreatedKey,
  PublicApiKey,
  PublicApiKeyFormValues,
  PublicApiSettings,
} from "./types";

const toDate = (value: string | null | undefined): Date | null =>
  value ? moment(value).toDate() : null;

export const transformPublicApiKey = (res: any): PublicApiKey => ({
  id: res.id,
  name: res.name ?? "",
  keyPrefix: res.keyPrefix ?? "",
  lastUsed: toDate(res.lastUsed),
  expiresAt: toDate(res.expiresAt),
  isExpired: !!res.isExpired,
  created: toDate(res.created),
});

export const transformPublicApiSettings = (res: any): PublicApiSettings => ({
  enabled: !!res?.enabled,
  maxKeys: res?.maxKeys ?? 10,
  keys: (res?.keys ?? []).map(transformPublicApiKey),
});

export const transformPublicApiCreatedKey = (res: any): PublicApiCreatedKey => ({
  ...transformPublicApiKey(res),
  key: res.key ?? "",
});

/**
 * Tijelo zahtjeva za izdavanje. Datum isteka iz kalendara vrijedi do kraja tog dana —
 * korisnik bira dan, ne trenutak — i šalje se kao ISO da poslužitelj ne nagađa zonu.
 */
export const transformPublicApiKeyOnCreate = (formValues: PublicApiKeyFormValues) => ({
  name: formValues.name.trim(),
  expiresAt: formValues.expiresAt
    ? moment(formValues.expiresAt).endOf("day").toISOString()
    : null,
});
